import { useMemo } from 'react';
import { SchedulerV3 } from '@frontend/api-schedule-v3';
import { useScheduleActionsContainerMethod } from '../../../../context/ScheduleActionsContainerContext';
import { useGetScheduleRequestAndAlertsCount } from '../../../../hooks/use-get-schedule-request-and-alerts-count';
import { ScheduleActionsContextType, ScheduleActionsContext } from './ScheduleActionsContext';
import { ScheduleActionsTabContent } from './ScheduleActionsTabContent';
import { SchedulePulseContactPatientsPanelV2 } from './ScheduleMassMessages/schedule-pulse-contact-patients-panel-v2';
import { SchedulePulseContactPatientsPanelV3 } from './ScheduleMassMessagesV3/schedule-pulse-contact-patients-panel-v3';

export const ScheduleActionsModalContainer = () => {
  const { hideTabs, closeModal } = useScheduleActionsContainerMethod();
  const { isScheduleV3FlagEnabled } = SchedulerV3.Helpers.useGetSchedulerV3FeatureFlagDetails();

  const {
    isAppointmentRequestCountLoading,
    isScheduleAlertsLoading,
    refetchAlertCount,
    scheduleAlertsCount,
    scheduleRequestCount,
    refetchAppointmentRequestCount,
  } = useGetScheduleRequestAndAlertsCount();

  const providerValue = useMemo<ScheduleActionsContextType>(
    () => ({
      isAppointmentRequestCountLoading,
      isScheduleAlertsLoading,
      closeModal: closeModal ? closeModal : () => {},
      refetchAlertCount: () => refetchAlertCount(),
      scheduleAlertsTotalCount: scheduleAlertsCount ?? 0,
      scheduleRequestsTotalCount: scheduleRequestCount?.total ?? 0,
      refetchAppointmentRequestCount: () => refetchAppointmentRequestCount(),
      scheduleRequestsCountByLocation: scheduleRequestCount?.locationScheduleRequestCounts ?? [],
      closeScheduleActionsModal: closeModal ? closeModal : () => {},
    }),
    [scheduleAlertsCount, scheduleRequestCount, isScheduleAlertsLoading, isAppointmentRequestCountLoading, closeModal]
  );

  if (hideTabs) {
    return isScheduleV3FlagEnabled ? <SchedulePulseContactPatientsPanelV3 /> : <SchedulePulseContactPatientsPanelV2 />;
  }

  return (
    <ScheduleActionsContext.Provider value={providerValue}>
      <ScheduleActionsTabContent />
    </ScheduleActionsContext.Provider>
  );
};
